package org.example.project.screens_shared

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div

internal val NOTE_COLORS = listOf(
    "#ffffff",
    "#d9d9d9",
    "#ff3b30",
    "#b00020",
    "#ff9500",
    "#ffcc00",
    "#34c759",
    "#00a86b",
    "#5ac8fa",
    "#007aff",
    "#0047ab",
    "#8b5a2b",
    "#ff2d95",
    "#af52de"
)

@Composable
internal fun NoteColorPicker(
    color: String,
    onColorChange: (String) -> Unit
) {
    Div({
        style {
            display(DisplayStyle.Grid)
            gridTemplateColumns("repeat(7, 20px)")
            gap(5.px)
        }
    }) {
        NOTE_COLORS.forEach { paletteColor ->
            Div({
                attr("title", paletteColor)
                style {
                    width(20.px)
                    height(20.px)
                    borderRadius(50.percent)
                    backgroundColor(Color(paletteColor))
                    property(
                        "border",
                        if (paletteColor == color) "2px solid #ffffff" else "1px solid rgba(255,255,255,0.30)"
                    )
                    property(
                        "box-shadow",
                        if (paletteColor == color) "0 0 0 2px rgba(91,155,255,0.85)" else "none"
                    )
                    property("box-sizing", "border-box")
                    cursor("pointer")
                }
                onClick { onColorChange(paletteColor) }
            })
        }
    }
}
